export default function about_us(param) {
	var offset = 0;
	if (param === "rs") {
		offset = $(".about_us .rs").offset().top;
	} else if (param === "join") {
		offset = $(".about_us .join").offset().top;
	}

	if (param) {
		$('html, body').animate({
	      scrollTop: offset - 80
	    }, 500);
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/js/pages/about_us.js
// module id = 11
// module chunks = 0